
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e/[marketSlug]/young-adults",
      function () {
        return require("private-next-pages/e/[marketSlug]/young-adults.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e/[marketSlug]/young-adults"])
      });
    }
  